import { logError, LogCategory } from "utils/sentryLogger";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "@bootstrap-styled/v4";
import React, { useState } from "react";
import { Alert } from "react-bootstrap";
import { request } from "hooks/useOkoApi/useOkoApi";
import { ConsensusActivityRender } from "../ConsensusActivityRender";
import { buildPreviewChallenge, handleSaveChallengeError } from "utils/challenge";
import { constants } from "utils";

export const PreviewConsensusQuestionModal = ({
                                                     challenge,
                                                     isModalOpen,
                                                     setIsModalOpen,
                                                     setNeedsRefresh }) => {
  const [error, setError] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    setIsModalOpen(false);
    setError(null);
  };

  const handleSave = async () => {
    try {
      setIsLoading(true);
      await request('questions/update', {
        payload: challenge
      });
      setNeedsRefresh(true);
      setIsLoading(false);
      setIsModalOpen(false);
    } catch (e) {
      setIsLoading(false);
      logError("Failed to save consensus question from preview", e, {
        category: LogCategory.ACTIVITY,
        activityType: "consensus",
      });
      setError(e?.detail || e?.message || "An unknown error occurred.");
    }
  };

  return (
    <div>
      <Modal size="lg" isOpen={isModalOpen} toggle={handleClose}>
        <ModalHeader>Preview Challenge</ModalHeader>
        <ModalBody>
          <ConsensusActivityRender
            hideQuestion={false}
            selectedIndex={null}
            challenge={buildPreviewChallenge(challenge)}
            disableOptions={null}
            onMCAnswer={() => {}}
            onORAnswer={() => {}}
            isMathJaxSet={false} // Needed to prevent race condition on MathJax typesetting.
            showPromptFormula
          />
        </ModalBody>
        <ModalFooter>
          <Button color="primary" disabled={isLoading} onClick={handleSave}>
            Save
          </Button>
          <Button color="secondary" disabled={isLoading} onClick={handleClose}>
            Cancel
          </Button>
        </ModalFooter>
        {error && <Alert style={{ overflowWrap: "break-word" }}
                         dismissible
                         onClose={() => setError(null)}
                         variant="danger">
          {JSON.stringify(handleSaveChallengeError(constants.CONSENSUS_ENUM, error))}
        </Alert>}
        {isLoading && <div style={{ alignSelf: "center", position: "fixed", top: "50%" }}>
          <FontAwesomeIcon
            icon={faSpinner}
            spin
            size="5x"
          />
        </div>}
      </Modal>
    </div>
  );
};
